export const ANALYSIS_UI_STEPS = ["profiles", "patterns", "audiences", "verify"];

const DISCOVERY_PENDING = new Set(["pending", "running"]);

export const backendStepToUiIndex = (step) => {
  if (step === "parse" || step === "map") return 0;
  if (step === "filter") return 1;
  if (step === "ingest") return 2;
  if (step === "explore") return 3;
  return 0;
};

export const displayAudienceName = (name) => String(name || "").trim();

export const evidenceRows = (row) =>
  Array.isArray(row?.evidence) ? row.evidence.filter((item) => item && item.concept) : [];

export const canSaveDiscoveredAudience = (row) => Boolean(row && row.save_eligible);

export const isDiscoveryAnalyzing = (analysis) =>
  DISCOVERY_PENDING.has(analysis?.discovery_job?.status);

export const isDiscoveryFailed = (analysis) =>
  analysis?.discovery_job?.status === "failed";

export const isDiscoveryReady = (analysis) =>
  analysis?.discovery_job?.status === "ready";

export const ingestSnapshotReady = (analysis) => {
  const snapshot = analysis?.snapshot || {};
  const n =
    Number(snapshot.profile_count || 0) + Number(snapshot.event_count || 0);
  return analysis?.status === "ready" && n > 0;
};

export const analysisUiStepIndex = (analysis) => {
  if (isDiscoveryAnalyzing(analysis) && ingestSnapshotReady(analysis)) {
    return 2;
  }
  return backendStepToUiIndex(analysis?.progress?.step);
};

// Calibrated on a 56,873-row GEZİNOMİ run (~250s analyze_frame + job overhead).
export const estimateDiscoverySeconds = (eventCount) => {
  const n = Math.max(0, Number(eventCount) || 0);
  return Math.min(900, Math.max(75, Math.round(40 + n * 0.0043)));
};

export const remainingDiscoverySeconds = ({
  startedAt,
  createdAt,
  eventCount,
  nowMs,
} = {}) => {
  const now = Number(nowMs) || Date.now();
  const start = Date.parse(startedAt || createdAt || "") || now;
  const elapsed = Math.max(0, (now - start) / 1000);
  return Math.round(estimateDiscoverySeconds(eventCount) - elapsed);
};
